module.exports = __webpack_public_path__ + "img/statisticsBackground.4f7fb90.webp";